import { isDefined } from '@enterprise/core';

import { getEnvVar } from '@/utilities/get-env-var';

const rawThresholdPercentage = getEnvVar('VITE_APP_NTH_THRESHOLD_PERCENTAGE');
const parsedThresholdPercentage = isDefined(rawThresholdPercentage)
  ? Number.parseFloat(rawThresholdPercentage)
  : Number.NaN;

/**
 * The Nth Calculator threshold percentage, derived from `VITE_APP_NTH_THRESHOLD_PERCENTAGE`.
 * Falls back to 5 if the env var is absent, non-numeric, or not a positive number.
 */
export const nthThresholdPercentage =
  Number.isFinite(parsedThresholdPercentage) && parsedThresholdPercentage > 0 ? parsedThresholdPercentage : 5;
